/*
 * @Author: wangbaihe
 * @Date: 2023-03-15 17:52:23
 * @LastEditors: wangbaihe
 * @LastEditTime: 2024-08-06 16:30:52
 * @FilePath: \common-mediax\src\apis\MediaCloudArticleMy\myTodo.js
 * @Description:
 */
import { createAPI } from '@common'

export default {
  // 获得我的待办根节点
  getMyAssignStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bttjho0nz0bttjhoTubuvt', 'get', config),
  // 获得我的待办子节点
  getMyFolders: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bttjho0nz0usff', 'get', config),
  // 获得我的待办列表
  getMyNewAssigns: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bttjho0nz0ofxBttjhot', 'get', config, {
      neverLoading: true,
      isHideErrorMessage: true
    }),
  // 获取列表
  getListData: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0f60mjtuebub', 'post', config),
  // 获取列表
  getLists: (config) => createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0f60mjtu', 'get', config),
  // 通知通过未通过
  getFinishAssignById: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bttjho0nz0gjojtiBttjhoCzJe', 'get', config),
  // 查看权限 待办
  getAssignStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bsujdmft0bttjho0tubuvt', 'get', config),
  // 查看权限消息
  getDetailStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bsujdmft0efubjm0tubuvt', 'get', config),
  // 我的消息左侧树
  getMyNoticeStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0opujdf0nz0opujdfTubuvt', 'get', config),
  // 获得我的消息列表
  getMyNewNotices: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0opujdf0nz0ofxOpujdft', 'get', config, {
      neverLoading: true,
      isHideErrorMessage: true
    }),
  // 设置为已读
  postReadNotices: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0opujdf0nz0sfbeOpujdft', 'post', config),
  // 设置为全部已读
  postReadNoticesAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0opujdf0nz0sfbeBmm', 'post', config),
  // 我的待办 受平台配置控制树
  getPermissionsChannels: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0bttjho0nz0diboofmt', 'get', config)
}
